import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"

Vue.use(Vuex)

export default {
	namespaced: true,
	state: {
		fetched_mails: []
	},
	getters: {
		fetched_mails: state => state.fetched_mails
	},
	mutations: {
		GETEMAILS(state, payload) {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/mail/fetch",
					{ tipo: payload },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					state.fetched_mails = JSON.parse(res.data.mail)
				})
				.catch(err => console.error(err))
		}
	},
	actions: {
		getemails({ commit }, type) {
			this.state.fetched_mails = []

			commit("GETEMAILS", type)
		}
	}
}
